module.exports = __webpack_public_path__ + "img/44400.a40c807e.jpg";